import { formatDate } from '@fukuri-admins/utils/common/date';
import React from 'react';
import { CompanyDepositTableData } from '../../../types/companyDeposit/CompanyDepositTableData';
import { formatCurrency } from '../../../utils/formatCurrency';
import styles from './styles.module.scss';

type Props = {
  rows: CompanyDepositTableData[];
};

export const CompanyDepositMobileCardList: React.FC<Props> = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <div className={styles.emptyCardList}>データなし</div>;
  }

  return (
    <div className={styles.cardListContainer} data-testid='card-list'>
      {rows.map((row, index) => (
        <div key={index} className={styles.card} data-testid={`card-${index}`}>
          <div className={styles.cardRow}>
            <span className={styles.cardDate}>
              {formatDate({ date: new Date(row.target_month), formatType: 'yyyy年M月' })}
            </span>
            <span className={styles.cardAmount}>{formatCurrency(row.amount)}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
